export default "__VITE_ASSET__CmKI6GRo__"